import React, { useEffect, useRef, useState } from "react";
import {
  PopoverArrow,
  StyledPopoverBox,
  TriggerWrapper,
} from "./PopoverComponent.styled";
import { createPortal } from "react-dom";

type PopoverComponentProps = {
  children: React.ReactNode;
  content: React.ReactNode;
  visible: boolean;
  setVisible: (visible: boolean) => void;
};

export const PopoverComponent = ({
  children,
  content,
  visible,
  setVisible,
}: PopoverComponentProps) => {
  const triggerRef = useRef<HTMLDivElement>(null);
  const popoverRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({ top: 0, right: 0 });

  const updatePosition = () => {
    if (triggerRef.current && popoverRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();

      let top = triggerRect.bottom + 12;
      let right = window.innerWidth - triggerRect.right - 45;

      setPosition({ top, right });
    }
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(e.target as Node) &&
        triggerRef.current &&
        !triggerRef.current.contains(e.target as Node)
      ) {
        setVisible(false);
      }
    };

    if (visible && triggerRef.current && popoverRef.current) {
      updatePosition();
      window.addEventListener("resize", updatePosition);
      window.addEventListener("scroll", updatePosition, true);
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [visible]);

  return (
    <>
      <TriggerWrapper ref={triggerRef} onClick={() => setVisible(!visible)}>
        {children}
      </TriggerWrapper>

      {createPortal(
        <StyledPopoverBox
          ref={popoverRef}
          $top={position.top}
          $right={position.right}
          $visible={visible}
        >
          {content}
          <PopoverArrow />
        </StyledPopoverBox>,
        document.body,
      )}
    </>
  );
};
